import * as React from "react";

import {FComponent} from "@Common/react/f-component";

interface P {
    next: (persisted: boolean) => JSX.Element;
}
interface S {
    persisted: boolean;
}
export class PageShow extends FComponent<P,S> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            persisted: false
        };

        this.onMount(() => {
            const listener = (event) => (
                event.persisted === true ? (
                    this.setState({
                        persisted: true
                    })
                ) : (
                    this.setState({
                        persisted: false
                    })
                )
            );
            window.addEventListener('pageshow', listener);
            this.onUnmount(() => window.removeEventListener("pageshow", listener));
        });
    }

    render() {
        const {next} = this.props;
        const {persisted} = this.state;

        return next(persisted);
    }
}
